import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import SmartLink from "./SmartLink";
import { DISCLAIMER } from "@/legal/disclaimer";

const footerLinks = {
  insideHxp: [
    { label: "See Our Story", href: "/about/" },
    { label: "Blog", href: "/blog/" },
  ],
  getAnswers: [
    { label: "FAQs", href: "/faq/" },
    { label: "Trip Pricing", href: "/trip-pricing/" },
    { label: "Paying For Your Trip", href: "/paying-for-your-trip/" },
    { label: "Privacy Policy", href: "/privacy/" },
    { label: "Policies", href: "/policies/" },
    { label: "Accessibility", href: "/accessibility/" },
    { label: "Trip Locations", href: "/go/register-footer" },
  ],
};

const Footer = () => {
  return (
    <footer className="bg-foreground text-background">
      <div className="mx-auto max-w-[1440px] px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand / logo */}
          <div className="space-y-4">
            {/* Brand kit: the full lockup (HXP over "Humanitarian Experience"), reversed white */}
            <img
              src="/images/hxp-lockup-white.png"
              width={960}
              height={791}
              alt="HXP — Humanitarian Experience"
              loading="lazy"
              className="h-24 w-auto"
            />
            <p className="font-body max-w-xs text-sm text-background/80">
              Changing lives through sustainable service.
            </p>
            <div className="flex items-center gap-4 pt-1">
              <a href="https://www.instagram.com/hxp.humanitarianexperience/" target="_self" aria-label="Instagram" className="transition-opacity hover:opacity-70">
                <Instagram size={20} />
              </a>
              <a href="https://www.facebook.com/humanitarianexperience/" target="_self" aria-label="Facebook" className="transition-opacity hover:opacity-70">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Inside HXP */}
          <div>
            <h3 className="font-subhead mb-4 text-sm uppercase tracking-[0.08em]">Inside HXP</h3>
            <ul className="space-y-2">
              {footerLinks.insideHxp.map((link) => (
                <li key={link.href}>
                  <SmartLink href={link.href} className="font-body text-sm text-background/80 transition-colors hover:text-background">
                    {link.label}
                  </SmartLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Get Answers */}
          <div>
            <h3 className="font-subhead mb-4 text-sm uppercase tracking-[0.08em]">Get Answers</h3>
            <ul className="space-y-2">
              {footerLinks.getAnswers.map((link) => (
                <li key={link.href}>
                  <SmartLink href={link.href} className="font-body text-sm text-background/80 transition-colors hover:text-background">
                    {link.label}
                  </SmartLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="font-subhead mb-4 text-sm uppercase tracking-[0.08em]">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:info@hxp.org" target="_self" className="font-body flex items-center gap-2 text-sm text-background/80 transition-colors hover:text-background">
                  <Mail size={15} /> info@hxp.org
                </a>
              </li>
              <li>
                <a href="tel:+18019004111" target="_self" className="font-body flex items-center gap-2 text-sm text-background/80 transition-colors hover:text-background">
                  <Phone size={15} /> (801) 900-4111
                </a>
              </li>
              <li>
                <a href="https://www.google.com/maps/place/Sweet+Candy+Building/@40.764093,-111.8970421,19z" target="_self" className="font-body flex items-start gap-2 text-sm text-background/80 transition-colors hover:text-background">
                  <MapPin size={15} className="mt-0.5 shrink-0" />
                  224 S 200 W, Salt Lake City, UT 84101 #100
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Legal disclaimer strip: LOCKED text lives in src/legal/disclaimer.ts */}
      <div className="border-t border-background/15">
        <div className="mx-auto max-w-[1440px] px-6 py-6">
          <p className="font-body text-xs leading-relaxed text-background/60">
            {DISCLAIMER}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-3">
            <p className="font-body text-xs text-background/50">
              © {new Date().getFullYear()} Humanitarian Experience. All rights reserved.
            </p>
            <utah-tech-powered-by
              theme="dark"
              size="tiny"
              href="https://utahtechman.com/?utm_source=hxp&utm_medium=footer&utm_campaign=powered_by"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
